import { isEqual } from 'lodash';
import { checkStatus, isAlert } from './checkStatus';
import { isNewerOrSame } from './dateUtils';

export default (asset, readings) => {
  let worstStatus = 'OFF';
  let worstMessage = 'OFF';
  let assetPosition = null;
  asset.updated = false;
  asset.sensors = asset.sensors.map(s => {
    const readingObj = readings[s.id];
    s.updated = false;

    if (
      !readingObj?.timestamp ||
      (s.reading_date && isNewerOrSame(s.reading_date, readingObj?.timestamp))
    ) {
      [worstStatus, worstMessage] = checkStatus(
        worstStatus,
        worstMessage,
        s.status,
        s.message,
      );
      return s;
    }

    const paramsObj = readingObj?.parameters;

    const nextStatus = paramsObj?.status || s.status;
    const nextMessage = paramsObj?.message || s.message;
    [worstStatus, worstMessage] = checkStatus(
      worstStatus,
      worstMessage,
      nextStatus,
      nextMessage,
    );

    let reading = paramsObj?.reading;
    if (reading == null) reading = s.reading;
    let { position } = s;
    if (paramsObj?.lat != null && paramsObj?.lng != null) {
      position = {
        lat: paramsObj?.lat,
        lng: paramsObj?.lng,
      };
      assetPosition = position;
    }
    const reading_date =
      readingObj?.timestamp && new Date(readingObj?.timestamp).toISOString();

    let { last_critical_read } = s;
    let { last_critical_date } = s;
    let { total_alerts } = s;
    if (paramsObj?.status && isAlert(paramsObj?.status)) {
      last_critical_read = paramsObj?.reading ?? last_critical_read;
      last_critical_date = reading_date ?? last_critical_date;
      ++total_alerts;
    }

    let { data } = s;
    if (data && paramsObj) data = paramsObj;

    const nextSensor = {
      ...s,
      reading,
      position,
      data,
      status: nextStatus,
      message: nextMessage,
      reading_date: reading_date ?? s.reading_date,
      last_critical_read,
      last_critical_date,
      total_alerts,
    };

    if (!isEqual(s, nextSensor)) {
      nextSensor.updated = true;
      asset.updated = true;
    }

    return nextSensor;
  });
  asset.status = worstStatus;
  asset.message = worstMessage;
  return [worstStatus, worstMessage, assetPosition];
};
